export default "__VITE_ASSET__Bwq25HTk__"